import { ApolloLink } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'

const uploadLink: ApolloLink = createUploadLink({
  uri: process.env.REACT_APP_DSP_BACKEND_API,
})

export default uploadLink
